import React from 'react';
import Grid from 'main/components/show/grid/grid.jsx';
import CuesheetHeader from 'main/components/show/cuesheet/header.jsx';
import EventViewActions from 'flux/actions/EventViewActions';
import TeamViewActions from 'flux/actions/TeamViewActions';
import EventShowListActions from 'flux/actions/EventShowListActions';
import Search from 'main/components/search/search.jsx';
import ActivityAuditList from 'main/components/activityAudit/list.jsx';

export default React.createClass({
  displayName: 'GridPage',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },
  render() {
    return (
      <div className="grid-container">
        <CuesheetHeader
          lightTheme
          displaySearch={false}
          displayItemRunTime={false}
          displayThemeSwitch={false}
          grid
        />
        <Grid {...this.props.params} />
        <Search />
        <ActivityAuditList />
      </div>
    );
  },

  componentDidMount() {
    let { teamId, eventId } = this.context.router.state.params;

    TeamViewActions.populate(teamId);
    EventViewActions.populate(teamId, eventId);
    EventShowListActions.populate(teamId, eventId);
  },
});
